export default __webpack_public_path__ + "static/media/main_hero.2ea94582.png";